import { render, staticRenderFns } from "./SprintRow.vue?vue&type=template&id=2c220bf6&scoped=true&"
import script from "./SprintRow.vue?vue&type=script&lang=ts&"
export * from "./SprintRow.vue?vue&type=script&lang=ts&"
import style0 from "./SprintRow.vue?vue&type=style&index=0&id=2c220bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c220bf6",
  null
  
)

export default component.exports